import axios from 'axios';
import { getAuth } from 'firebase/auth';
import VacancyDraft from '../models/VacancyDraft';
import InstagramDraft from '../models/InstagramDraft';

const API_BASE_URL = 'https://europe-west3-hyper-e122e.cloudfunctions.net';

const AdminService = {

  async createAdminVacancy(vacancyPayload) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(`${API_BASE_URL}/create_admin_vacancy`, vacancyPayload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при создании админ-вакансии:", error.response?.data || error.message);
      throw error;
    }
  },

  async createAdminCompany(companyPayload) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(`${API_BASE_URL}/create_admin_company`, companyPayload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при создании компании:", error.response?.data || error.message);
      throw error;
    }
  },

    async createAdminEvent(eventPayload) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(`${API_BASE_URL}/create_admin_event`, eventPayload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при создании ивента:", error.response?.data || error.message);
      throw error;
    }
  },

  async createAdminTelegramTopic(topicPayload) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(
        `${API_BASE_URL}/create_admin_telegram_topic`,
        topicPayload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(
        "❌ Ошибка при создании Telegram-топика:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  async getAdminTelegramTopics() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.get(
        `${API_BASE_URL}/get_admin_telegram_topics`,
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        }
      );

      return response.data.topics;
    } catch (error) {
      console.error(
        "❌ Ошибка при получении Telegram-топиков:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  async getAdminTelegramTopics() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      const response = await axios.get(
        `${API_BASE_URL}/get_admin_telegram_topics`,
        {
          headers: {
            "Authorization":
              `Bearer ${token}`
          }
        }
      );
  
      return response.data.topics;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при получении Telegram-топиков:",
        error.response?.data
          || error.message
      );
  
      throw error;
    }
  },
  
  async getPendingVacancies() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      const response = await axios.get(
        `${API_BASE_URL}/get_pending_vacancies`,
        {
          headers: {
            "Authorization":
              `Bearer ${token}`
          }
        }
      );
  
      return (
        response.data.pending_vacancies
        ?? []
      );
  
    } catch (error) {
      console.error(
        "❌ Ошибка при получении вакансий на модерации:",
        error.response?.data
          || error.message
      );
  
      throw error;
    }
  },
  
  async approvePendingVacancy(
    vacancyId
  ) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      const response = await axios.post(
        `${API_BASE_URL}/approve_pending_vacancy`,
        {
          vacancy_id: vacancyId
        },
        {
          headers: {
            "Content-Type":
              "application/json",
  
            "Authorization":
              `Bearer ${token}`
          }
        }
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при публикации вакансии:",
        error.response?.data
          || error.message
      );
  
      throw error;
    }
  },
  async getPendingEvents() {
    try {
  
      const auth =
        getAuth();
  
      const currentUser =
        auth.currentUser;
  
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
  
      const token =
        await currentUser.getIdToken(true);
  
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
  
      const response =
        await axios.get(
          `${API_BASE_URL}/get_pending_events`,
          {
            headers: {
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
  
      const data =
        response.data
        || {};
  
  
      console.log(
        "📦 get_pending_events response:",
        data
      );
  
  
      return {
  
        pendingEvents:
          Array.isArray(
            data.pending_events
          )
            ? data.pending_events
            : [],
  
        createEvents:
          Array.isArray(
            data.create_events
          )
            ? data.create_events
            : [],
  
        editEvents:
          Array.isArray(
            data.edit_events
          )
            ? data.edit_events
            : [],
  
        counts: {
          total:
            Number(
              data.counts?.total
              ?? 0
            ),
  
          create:
            Number(
              data.counts?.create
              ?? 0
            ),
  
          edit:
            Number(
              data.counts?.edit
              ?? 0
            )
        }
  
      };
  
  
    } catch (error) {
  
      console.error(
        "❌ Ошибка при получении ивентов на модерации:",
        error.response?.data
        || error.message
      );
  
  
      throw error;
  
    }
  },

  async approvePendingEvent(
    eventId
  ) {
    try {
  
      const auth =
        getAuth();
  
      const currentUser =
        auth.currentUser;
  
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
  
      const token =
        await currentUser.getIdToken(
          true
        );
  
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
  
      const response =
        await axios.post(
          `${API_BASE_URL}/approve_pending_event`,
          {
            event_id:
              eventId
          },
          {
            headers: {
              "Content-Type":
                "application/json",
  
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
  
      return response.data;
  
  
    } catch (error) {
  
      console.error(
        "❌ Ошибка при публикации ивента:",
        error.response?.data
        || error.message
      );
  
  
      throw error;
    }
  },

  async uploadAdminCompanyImages(
    companyId,
    images
  ) {
    try {
      const auth = getAuth();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(
          true
        );
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      if (!companyId) {
        throw new Error(
          "❌ companyId не указан"
        );
      }
  
      const imageFiles =
        Array.from(
          images || []
        );
  
      if (
        imageFiles.length === 0
      ) {
        throw new Error(
          "❌ Не выбраны изображения"
        );
      }
  
      // ========================================================
      // FORM DATA
      // ========================================================
  
      const formData =
        new FormData();
  
      formData.append(
        "company_id",
        companyId
      );
  
      imageFiles.forEach(
        (image) => {
          formData.append(
            "images",
            image
          );
        }
      );
  
      // ========================================================
      // REQUEST
      // ========================================================
  
      const response =
        await axios.post(
          `${API_BASE_URL}/upload_admin_company_images`,
          formData,
          {
            headers: {
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
      console.log(
        "✅ Изображения компании загружены:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при загрузке изображений компании:",
        error.response?.data
          || error.message
      );
  
      throw error;
    }
  },

  async getAdminVacancyDrafts() {

    try {
  
      const auth =
        getAuth();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
  
        throw new Error(
          "❌ Пользователь не авторизован"
        );
  
      }
  
      const token =
        await currentUser.getIdToken(
          true
        );
  
      if (!token) {
  
        throw new Error(
          "❌ Токен авторизации не найден"
        );
  
      }
  
      // ========================================================
      // REQUEST
      // ========================================================
  
      const response =
        await axios.get(
          `${API_BASE_URL}/get_admin_vacancy_drafts`,
          {
            headers: {
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
      const data =
        response.data
        || {};
  
      console.log(
        "📦 get_admin_vacancy_drafts response:",
        data
      );
  
      // ========================================================
      // DRAFTS
      // ========================================================
  
      const vacancyDrafts =
        VacancyDraft.fromArray(
          Array.isArray(
            data.vacancy_drafts
          )
            ? data.vacancy_drafts
            : []
        );
  
      // ========================================================
      // COUNTS
      // ========================================================
  
      const counts = {
  
        total:
          Number(
            data.counts?.total
            ?? 0
          ),
  
        ready:
          Number(
            data.counts?.ready
            ?? 0
          ),
  
        company: {
  
          pending:
            Number(
              data.counts
                ?.company
                ?.pending
              ?? 0
            ),
  
          resolved:
            Number(
              data.counts
                ?.company
                ?.resolved
              ?? 0
            ),
  
          notFound:
            Number(
              data.counts
                ?.company
                ?.not_found
              ?? 0
            ),
  
          ambiguous:
            Number(
              data.counts
                ?.company
                ?.ambiguous
              ?? 0
            ),
  
          failed:
            Number(
              data.counts
                ?.company
                ?.failed
              ?? 0
            )
        },
  
        image: {
  
          pending:
            Number(
              data.counts
                ?.image
                ?.pending
              ?? 0
            ),
  
          resolved:
            Number(
              data.counts
                ?.image
                ?.resolved
              ?? 0
            ),
  
          notFound:
            Number(
              data.counts
                ?.image
                ?.not_found
              ?? 0
            ),
  
          failed:
            Number(
              data.counts
                ?.image
                ?.failed
              ?? 0
            )
        }
      };
  
      // ========================================================
      // RESULT
      // ========================================================
  
      return {
        vacancyDrafts,
        counts
      };
  
    } catch (error) {
  
      console.error(
        "❌ Ошибка при получении черновиков вакансий:",
        error.response?.data
          || error.message
      );
  
      throw error;
  
    }
  
  },

  async publishAdminVacancyDraft(
    draftId
  ) {
  
    try {
  
      const auth =
        getAuth();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
  
        throw new Error(
          "❌ Пользователь не авторизован"
        );
  
      }
  
      const token =
        await currentUser.getIdToken(
          true
        );
  
      if (!token) {
  
        throw new Error(
          "❌ Токен авторизации не найден"
        );
  
      }
  
      if (!draftId) {
  
        throw new Error(
          "❌ draftId не указан"
        );
  
      }
  
      // ========================================================
      // REQUEST
      // ========================================================
  
      const response =
        await axios.post(
          `${API_BASE_URL}/publish_admin_vacancy_draft`,
          {
            draft_id:
              draftId
          },
          {
            headers: {
              "Content-Type":
                "application/json",
  
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
      console.log(
        "✅ VacancyDraft опубликован:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
  
      console.error(
        "❌ Ошибка при публикации VacancyDraft:",
        error.response?.data
          || error.message
      );
  
      throw error;
  
    }
  
  },

  async downloadAdminExternalImage(url) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }
  
      const token = await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error("❌ Токен авторизации не найден");
      }
  
      if (!url) {
        throw new Error("❌ URL изображения не указан");
      }
  
      const response = await axios.post(
        `${API_BASE_URL}/download_admin_external_image`,
        {
          url
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          responseType: "blob"
        }
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка скачивания внешнего изображения:",
        error.response?.data || error.message
      );
  
      throw error;
    }
  },

  async deleteAdminPendingVacancyDraft(draftId) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }
  
      const token = await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error("❌ Токен авторизации не найден");
      }
  
      if (!draftId) {
        throw new Error("❌ draftId не указан");
      }
  
      const response = await axios.post(
        `${API_BASE_URL}/delete_admin_pending_vacancy_draft`,
        {
          draft_id: draftId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );
  
      console.log(
        "✅ VacancyDraft удалён:",
        response.data
      );
  
      return response.data;
    } catch (error) {
      console.error(
        "❌ Ошибка при удалении VacancyDraft:",
        error.response?.data || error.message
      );
  
      throw error;
    }
  },

  async updateAdminVacancyDraftDescription(
    draftId,
    description
  ) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      if (!draftId) {
        throw new Error(
          "❌ draftId не указан"
        );
      }
  
      const normalizedDescription =
        String(
          description || ""
        ).trim();
  
      if (!normalizedDescription) {
        throw new Error(
          "❌ description не может быть пустым"
        );
      }
  
      const response =
        await axios.post(
          `${API_BASE_URL}/update_admin_vacancy_draft`,
          {
            draft_id: draftId,
            description:
              normalizedDescription
          },
          {
            headers: {
              "Content-Type":
                "application/json",
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
      console.log(
        "✅ Description VacancyDraft обновлён:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при обновлении description VacancyDraft:",
        error.response?.data
        || error.message
      );
  
      throw error;
    }
  },
  
  
  async updateAdminVacancyDraftTitle(
    draftId,
    title
  ) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      if (!draftId) {
        throw new Error(
          "❌ draftId не указан"
        );
      }
  
      const normalizedTitle =
        String(
          title || ""
        ).trim();
  
      if (!normalizedTitle) {
        throw new Error(
          "❌ title не может быть пустым"
        );
      }
  
      const response =
        await axios.post(
          `${API_BASE_URL}/update_admin_vacancy_draft`,
          {
            draft_id: draftId,
            title:
              normalizedTitle
          },
          {
            headers: {
              "Content-Type":
                "application/json",
              "Authorization":
                `Bearer ${token}`
            }
          }
        );
  
      console.log(
        "✅ Title VacancyDraft обновлён:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при обновлении title VacancyDraft:",
        error.response?.data
        || error.message
      );
  
      throw error;
    }
  },

  async deleteAdminVacancy(vacancyId) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      if (!vacancyId) {
        throw new Error(
          "❌ vacancyId не указан"
        );
      }
  
      const response = await axios.post(
        `${API_BASE_URL}/delete_admin_vacancy`,
        {
          vacancy_id: vacancyId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );
  
      console.log(
        "✅ Админ-вакансия удалена:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка при удалении админ-вакансии:",
        error.response?.data || error.message
      );
  
      throw error;
    }
  },

  async runPipelineVacancyDrafts({
    limit = 200,
    retryCompanies = true,
    retryImages = true
  } = {}) {
    try {
      const auth =
        getAuth();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "❌ Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(
          true
        );
  
      if (!token) {
        throw new Error(
          "❌ Токен авторизации не найден"
        );
      }
  
      console.log(
        "🚀 Запускаем vacancy preparation pipeline",
        {
          limit,
          retryCompanies,
          retryImages
        }
      );
  
      const response =
        await axios.post(
          `${API_BASE_URL}/run_pipeline_prepare_vacancies`,
          {
            limit,
            retry_companies:
              retryCompanies,
            retry_images:
              retryImages
          },
          {
            headers: {
              "Content-Type":
                "application/json",
              "Authorization":
                `Bearer ${token}`
            },
  
            // Pipeline может работать долго.
            timeout: 0
          }
        );
  
      console.log(
        "✅ Vacancy preparation pipeline finished:",
        response.data
      );
  
      return response.data;
  
    } catch (error) {
      console.error(
        "❌ Ошибка vacancy preparation pipeline:",
        error.response?.data
        || error.message
      );
  
      throw error;
    }
  },


  // ============================================================
  // ADMIN — UPDATE WORKER RATING
  // ============================================================

  async updateWorkerRating(workerId, rating) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }

      const token = await currentUser.getIdToken(true);

      if (!token) {
        throw new Error("❌ Токен авторизации не найден");
      }

      if (!workerId || typeof workerId !== "string") {
        throw new Error("❌ workerId не указан");
      }

      if (![60, 100, 140].includes(rating)) {
        throw new Error("❌ Недопустимое значение рейтинга");
      }

      // ========================================================
      // REQUEST
      // ========================================================

      const response = await axios.post(
        `${API_BASE_URL}/admin_update_worker_rating`,
        {
          worker_id: workerId,
          rating: rating
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      console.log(
        "✅ Рейтинг пользователя обновлён:",
        response.data
      );

      return response.data;

    } catch (error) {
      console.error(
        "❌ Ошибка при обновлении рейтинга пользователя:",
        error.response?.data || error.message
      );

      throw error;
    }
  },

// ============================================================
// ADMIN — GET INSTAGRAM DRAFTS
// ============================================================

async getInstagramDrafts({
  limit = 20,
  status = "pending_review",
  cursor = null,
  includePreviewUrls = true
} = {}) {

  try {

    // ========================================================
    // AUTH
    // ========================================================

    const auth = getAuth();

    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error(
        "❌ Пользователь не авторизован"
      );
    }

    const token = await currentUser.getIdToken(true);

    if (!token) {
      throw new Error(
        "❌ Токен авторизации не найден"
      );
    }

    // ========================================================
    // REQUEST
    // ========================================================

    const response = await axios.post(
      `${API_BASE_URL}/get_instagram_drafts`,
      {
        limit,
        status,
        cursor,
        include_preview_urls: includePreviewUrls
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        timeout: 60000
      }
    );

    // ========================================================
    // RESPONSE
    // ========================================================

    const data = response.data || {};

    if (data.success !== true) {
      throw new Error(
        data.error || "Не удалось получить Instagram-драфты"
      );
    }

    console.log(
      "📦 get_instagram_drafts response:",
      data
    );

    // ========================================================
    // INSTAGRAM DRAFTS
    // ========================================================

    const instagramDrafts = InstagramDraft.fromApiArray(
      Array.isArray(data.drafts)
        ? data.drafts
        : []
    );

    // ========================================================
    // PAGINATION
    // ========================================================

    const pagination = {
      limit: Number(
        data.pagination?.limit ?? limit
      ),

      hasMore: Boolean(
        data.pagination?.has_more
      ),

      nextCursor:
        data.pagination?.next_cursor ?? null
    };

    // ========================================================
    // RESULT
    // ========================================================

    console.log(
      "✅ Instagram-драфты загружены:",
      instagramDrafts.length
    );

    return {
      instagramDrafts,

      count: instagramDrafts.length,

      pagination,

      statusFilter: data.status_filter || status,

      previewUrlExpiresIn:
        data.preview_url_expires_in ?? null
    };

  } catch (error) {

    console.error(
      "❌ Ошибка при получении Instagram-драфтов:",
      error.response?.data || error.message
    );

    throw error;
  }
},


// ============================================================
// EDIT INSTAGRAM POST
// ============================================================

async editInstagramPost({
  digestId,
  slideId,
  action = "delete",
}) {
  try {
    // ========================================================
    // VALIDATION
    // ========================================================

    if (!digestId || !slideId) {
      throw new Error(
        "Не передан ID дайджеста или слайда"
      );
    }

    if (action !== "delete") {
      throw new Error(
        "Неподдерживаемое действие"
      );
    }

    // ========================================================
    // FIREBASE AUTH
    // ========================================================

    const auth = getAuth();

    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error(
        "Пользователь не авторизован"
      );
    }

    const token = await currentUser.getIdToken();

    if (!token) {
      throw new Error(
        "Не удалось получить Firebase ID Token"
      );
    }

    // ========================================================
    // REQUEST
    // ========================================================

    const response = await axios.post(
      `${API_BASE_URL}/edit_instagram_post`,
      {
        digest_id: digestId,
        slide_id: slideId,
        action,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 60000,
      }
    );

    // ========================================================
    // VALIDATE RESPONSE
    // ========================================================

    const result = response.data;

    if (!result?.success) {
      throw new Error(
        result?.error ||
        "Не удалось удалить слайд"
      );
    }

    console.log(
      "✅ Instagram slide deleted:",
      {
        digestId,
        slideId,
        storageDeleted: result.storage_deleted,
        storageCleanupPending:
          result.storage_cleanup_pending,
      }
    );

    return result;

  } catch (error) {
    console.error(
      "❌ editInstagramPost error:",
      error.response?.data || error.message
    );

    throw error;
  }
},

  // ============================================================
  // PUBLISH INSTAGRAM POST
  // ============================================================

  async publishInstagramPost({
    digestId,
    dryRun = false,
  }) {
    try {

      if (!digestId) {
        throw new Error(
          "Не передан ID Instagram-дайджеста"
        );
      }

      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error(
          "Пользователь не авторизован"
        );
      }

      const token = await currentUser.getIdToken();

      const response = await axios.post(
        `${API_BASE_URL}/publish_instagram_post`,
        {
          digest_id: digestId,
          dry_run: dryRun,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          timeout: 550000,
        }
      );

      const result = response.data;

      if (!result?.success) {
        throw new Error(
          result?.error ||
          "Не удалось опубликовать Instagram-дайджест"
        );
      }

      return result;

    } catch (error) {

      console.error(
        "publishInstagramPost error:",
        error.response?.data || error.message
      );

      throw error;
    }
  },


};

export default AdminService;